import Vue from 'vue'
import Router from 'vue-router'
import Main from './views/Main.vue'
import store from './store'

/*001*/ import Welcome from './views/educator/Welcome.vue'
/*002*/ import Package from './views/educator/Package.vue'
/*003*/ import AboutYou from './views/educator/AboutYou.vue'
/*004*/ import YourAddress from './views/educator/YourAddress.vue'
/*009*/ import HelloUser from './views/educator/HelloUser.vue'
/*005*/ import PreviousPolicies from './views/educator/PreviousPolicies.vue'
/*006*/ import PreviousClaims from './views/educator/PreviousClaims.vue'
/*007*/ import OutstandingClaims from './views/educator/OutstandingClaims.vue'
/*007.5*/ import SmallBusinessDisclaimer from './views/educator/SmallBusinessDisclaimer.vue'
/*008*/ import RegisteredForGST from './views/educator/RegisteredForGST.vue'
/*010*/ import EducatorStartDateOfPolicy from './views/educator/StartDateOfPolicy.vue'
/*011*/ import Premium from './views/educator/PremiumQuote.vue'
/*012*/ import CoordinationUnit from './views/educator/CoordinationUnit.vue'
/*013 - new*/ import MailingAddress from './views/educator/MailingAddress.vue'
/*014 - new*/import CoveredIndividuals from './views/educator/CoveredIndividuals.vue'
/*015*/ import AddOnsLegal from './views/educator/AddOnsLegal.vue'
import EducatorPayment from './views/educator/Payment.vue'
import PremiumFunding from './views/educator/PremiumFunding.vue'
import EducatorFinalQuote from './views/educator/FinalQuote.vue'
import EducatorConfirmation from './views/educator/Confirmation.vue'
import EducatorTermsAndConditions from './views/educator/TermsAndConditions.vue'

/*001*/ import ServiceWelcome from './views/service/ServiceWelcome.vue'
/*002*/ import AlreadyAMember from './views/service/ServiceAlreadyAMember.vue'
/*003*/ import FindYourService from './views/service/ServiceFindYourService.vue'
/*004*/ import AuthorisedRepresentative from './views/service/ServiceAuthorisedRepresentative.vue'
/*005*/ import NumberOfEducators from './views/service/ServiceNumberOfEducators.vue'
/*006*/ import ServicePreviousPolicies from './views/service/ServicePreviousPolicies.vue'
/*007*/ import ServicePreviousClaims from './views/service/ServicePreviousClaims.vue'
/*008*/ import ServiceOutstandingClaims from './views/service/ServiceOutstandingClaims.vue'
/*008.5*/ import ServiceSmallBusinessDisclaimer from './views/service/ServiceSmallBusinessDisclaimer.vue'
/*009*/ import ServiceRegisteredForGST from './views/service/ServiceRegisteredForGST.vue'
/*010*/ import ServiceEmailAndPhone from './views/service/ServiceEmailAndPhone.vue'
/*011*/ import ServiceAdditionalBranches from './views/service/ServiceAdditionalBranches.vue'
/*011.5*/ import ServiceAdditionalBranchesAddress from './views/service/ServiceAdditionalBranchesAddress.vue'
/*012*/ import ServiceStartDateOfPolicy from './views/service/ServiceStartDateOfPolicy.vue'
/*013*/ import ServicePremium from './views/service/ServicePremiumQuote.vue'
/*014*/ import ServiceAddOn from './views/service/ServiceAddOns.vue'
/*015*/ import ServiceResidentialMailing from './views/service/ServiceResidentialMailing.vue'
/*016*/ import ServiceTermsAndConditions from './views/service/ServiceTermsAndConditions.vue'

/* Renewals */
import Renewals from './views/renewals/Renewals.vue'
import ThankYou from './views/renewals/ThankYou.vue'
import PageNotFound from './views/renewals/PageNotFound.vue'

/* Policy Renewals */
import PolicyRenewal from './views/policy_renewal/PolicyRenewal.vue'

/* Purchase Insurance Online */
import PurchasePolicy from './views/purchase_policy/PurchasePolicy'
import PurchasePolicyTermsAndConditions from "./views/purchase_policy/PurchasePolicyTermsAndConditions";
import PurchaseResult from "./views/purchase_policy/PurchaseResult";
import PurchasePolicyElantisSuccess from "./views/purchase_policy/PurchasePolicyElantisSuccess";

Vue.use(Router);
const router = new Router({
  routes: [
    {
      path: '/policy-renewal/:quote_reference_id',
      name: 'PolicyRenewal',
      component: PolicyRenewal,
      props: true,
      beforeEnter: async (to, from, next) => {
        let payload = {
          method: 'get',
          url: `${window.location.origin}/api/cfa/check_if_user_logged_in.json`
        },
        response = await store.dispatch('fetchData', payload);

        if (response.data.email) {
          store.commit('mutate', {
            property: 'onlineRenewalEmail',
            value: response.data.email
          })
          next()
        } else {
          window.location.href = "/unauthorized" 
        }
      }
    },

    {
      path: '/renewals',
      name: 'Renewals',
      component: Renewals
    },

    /* Purchase Insurance Online Block */
    {
      path: '/purchase-policy',
      name: 'PurchasePolicy',
      component: PurchasePolicy,
      props: true,
      beforeEnter: async (to, from, next) => {
        let payload = {
          method: 'get',
          url: `${window.location.origin}/api/cfa/check_if_user_logged_in.json`
        },
        response = await store.dispatch('fetchData', payload);
        if(response.data.email) {
          store.commit('mutate', {
            property: 'sessionEmail',
            value: response.data.email
          })
          next()
        } else {
          next()
        }
      }
    }, 
    {
      path: '/purchase-policy/payment',
      name: 'PurchasePolicyTermsAndConditions',
      component: PurchasePolicyTermsAndConditions,
      props: true
    },
    {
      path: '/purchase-policy/success/:env/:transaction_api_token/:token/:session_id/:user_id',
      name: 'PurchasePolicyElantisSuccess',
      component: PurchasePolicyElantisSuccess,
      props: true
    },
    {
      path: '/purchase-policy/result',
      name: 'PurchaseResult',
      component: PurchaseResult,
      props: true
    },
    /* End Of Purchase Insurance Online Block */

    // {
    //   path: '/',
    //   name: 'Home',
    //   component: Main,
    //   props: true
    // },
    {
      path: '/',
      redirect: '/purchase-policy'
    },
    {
      path: '/educator',
      name: 'Welcome',
      component: Welcome,
      props: true
    },
    {
      path: '/educator/select-a-package',
      name: 'Package',
      component: Package,
      props: true
    },
    {
      path: '/educator/name',
      name: 'AboutYou',
      component: AboutYou,
      props: true
    },
    {
      path: '/educator/about-you',
      name: 'HelloUser',
      component: HelloUser,
      props: true
    },
    {
      path: '/educator/your-address',
      name: 'YourAddress',
      component: YourAddress,
      props: true
    },
    {
      path: '/educator/previous-policies',
      name: 'PreviousPolicies',
      component: PreviousPolicies,
      props: true
    },
    {
      path: '/educator/previous-claims',
      name: 'PreviousClaims',
      component: PreviousClaims,
      props: true
    },
    {
      path: '/educator/pending-claims',
      name: 'OutstandingClaims',
      component: OutstandingClaims,
      props: true
    },
    {
      path: '/educator/small-business-disclaimer',
      name: 'SmallBusinessDisclaimer',
      component: SmallBusinessDisclaimer,
      props: true
    },
    {
      path: '/educator/registered-for-gst',
      name: 'RegisteredForGST',
      component: RegisteredForGST,
      props: true
    },
    {
      path: '/educator/premium',
      name: 'Premium',
      component: Premium
    },
    {
      path: '/educator/coordination-unit',
      name: 'CoordinationUnit',
      component: CoordinationUnit
    },
    {
      path: '/educator/start-date-of-policy',
      name: 'EducatorStartDateOfPolicy',
      component: EducatorStartDateOfPolicy
    },
    {
      path: '/educator/add-ons-legal',
      name: 'AddOnsLegal',
      component: AddOnsLegal
    },
    {
      path: '/educator/covered-individuals',
      name: 'CoveredIndividuals',
      component: CoveredIndividuals
    },
    {
      path: '/educator/mailing-address',
      name: 'MailingAddress',
      component: MailingAddress
    },
    {
      path: '/educator/payment',
      name: 'EducatorPayment',
      component: EducatorPayment
    },
    {
      path: '/educator/premium-funding',
      name: 'PremiumFunding',
      component: PremiumFunding
    },
    {
      path: '/educator/final-quote',
      name: 'EducatorFinalQuote',
      component: EducatorFinalQuote
    },
    {
      path: '/educator/confirmation',
      name: 'EducatorConfirmation',
      component: EducatorConfirmation
    },
    {
      path: '/educator/terms-and-conditions',
      name: 'EducatorTermsAndConditions',
      component: EducatorTermsAndConditions,
      props: true
    },
    // service
    {
      path: '/service',
      name: 'ServiceWelcome',
      component: ServiceWelcome,
      props: true
    },
    {
      path: '/service/already-a-member',
      name: 'AlreadyAMember',
      component: AlreadyAMember,
      props: true
    },
    {
      path: '/service/find-your-service',
      name: 'FindYourService',
      component: FindYourService,
      props: true
    },
    {
      path: '/service/authorised-representative',
      name: 'AuthorisedRepresentative',
      component: AuthorisedRepresentative,
      props: true
    },
    {
      path: '/service/number-of-educators',
      name: 'NumberOfEducators',
      component: NumberOfEducators,
      props: true
    },
    {
      path: '/service/previous-policies',
      name: 'ServicePreviousPolicies',
      component: ServicePreviousPolicies,
      props: true
    },
    {
      path: '/service/previous-claims',
      name: 'ServicePreviousClaims',
      component: ServicePreviousClaims,
      props: true
    },
    {
      path: '/service/pending-claims',
      name: 'ServiceOutstandingClaims',
      component: ServiceOutstandingClaims,
      props: true
    },
    {
      path: '/service/small-business-disclaimer',
      name: 'ServiceSmallBusinessDisclaimer',
      component: ServiceSmallBusinessDisclaimer,
      props: true
    },
    {
      path: '/service/registered-for-gst',
      name: 'ServiceRegisteredForGST',
      component: ServiceRegisteredForGST,
      props: true
    },
    {
      path: '/service/email-address-and-phone-number',
      name: 'ServiceEmailAndPhone',
      component: ServiceEmailAndPhone,
      props: true
    },
    {
      path: '/service/premium',
      name: 'ServicePremium',
      component: ServicePremium,
      props: true
    },
    {
      path: '/service/add-ons',
      name: 'ServiceAddOn',
      component: ServiceAddOn,
    },
    {
      path: '/service/additional-branches',
      name: 'ServiceAdditionalBranches',
      component: ServiceAdditionalBranches,
      props: true
    },
    {
      path: '/service/additional-branches-address',
      name: 'ServiceAdditionalBranchesAddress',
      component: ServiceAdditionalBranchesAddress,
      props: true
    },
    {
      path: '/service/start-date-of-policy',
      name: 'ServiceStartDateOfPolicy',
      component: ServiceStartDateOfPolicy,
      props: true
    },
    {
      path: '/service/residential-mailing',
      name: 'ServiceResidentialMailing',
      component: ServiceResidentialMailing,
      props: true
    },
    {
      path: '/thank-you/:quote_reference_id',
      name: 'ThankYou',
      component: ThankYou,
      props: true,
      beforeEnter: async (to, from, next) => {
        let payload = {
          method: 'get',
          url: `${window.location.origin}/api/cfa/check_if_user_logged_in.json`
        },
        response = await store.dispatch('fetchData', payload);
        if(response.data.email) {
          store.commit('mutate', {
            property: 'sessionEmail',
            value: response.data.email
          })
          next()
        } else {
          window.location.href = "/unauthorized" 
        }

      }
    },
    {
      path: "*", component: PageNotFound
    }
  ]
})

export default router


/* 
Marky: Ask marky how to run a login validation before executing the route url
*/